export default {
  'printoutSettings.title': '打印票据设置',
  'printoutSettings.printSettings': '打印设置',
  'printoutSettings.section.general': '基本',
  'printoutSettings.section.kitchen': '厨房小票',
  'printoutSettings.section.runner': '跑堂小票',
  'printoutSettings.section.bill': '账单',
  'printoutSettings.section.receipt': '收据',
  'printoutSettings.section.label': '贴纸',
  'printoutSettings.section.packing': '外带单',
  'printoutSettings.section.clockoutSummary': '下班打卡小结',
  'printoutSettings.section.printingTaskExpirationTime': '打印任务过期时间',

  'printoutSettings.block.price': '购物车价格',
  'printoutSettings.block.display': '显示',
  'printoutSettings.block.general': '基本设置',
  'printoutSettings.block.style': '样式',
  'printoutSettings.block.closeoutSummary': '日结单',
  'printoutSettings.block.enlargeTheDispaly': '加大显示',

  'printoutSettings.field.enableRollupItemPrice': '菜价汇总附加选项和偏好价格',
  'printoutSettings.block.price.desc': '影响POS App订单, 以及厨房小票，外带单，账单，收据打印',
  'printoutSettings.block.price.zero.title': '价格为0的菜品',
  'printoutSettings.block.price.customizationAndPreference.zero.title': '价格为0的附加选项和菜品偏好',

  'printoutSettings.field.price.groupPrintPriceIncludeCustomizationAndPreference': '是，菜品价格包含附加选项和偏好价格',
  'printoutSettings.field.price.sepatatePrintPriceForCustomizationAndPreference': '否，独立显示附加选项和偏好价格',

  'printoutSettings.field.price.zero.printPriceZeroItemWithPrice': '打印菜品及其价格 ($0.00)',
  'printoutSettings.field.price.zero.printPriceZeroItemNoRice': '只打印菜品',
  'printoutSettings.field.price.zero.notPrintPriceZeroItem': '不打印菜品',

  'printoutSettings.field.price.customizationAndPreference.zero.printPriceZeroItemWithPrice':
    '打印附加选项和菜品偏好及其价格 ($0.00)',
  'printoutSettings.field.price.customizationAndPreference.zero.printPriceZeroItemNoRice':
    '只打印菜品附加选项和菜品偏好',
  'printoutSettings.field.price.customizationAndPreference.zero.notPrintPriceZeroItem': '不打印附加选项和菜品偏好',

  'printoutSettings.field.numberOfGuests': '客人数量',
  'printoutSettings.field.orderSource': '订单来源',
  'printoutSettings.field.customerName': '客人姓名',
  'printoutSettings.field.customerPhoneNumber': '客人电话',
  'printoutSettings.field.showSeatNumber': '座位号',
  'printoutSettings.field.restaurantLogo': '餐厅Logo',
  'printoutSettings.field.deliveryAddress': '递送地址',
  'printoutSettings.field.isDriver': '司机',
  'printoutSettings.field.restaurantSlogan': '餐厅标语',
  'printoutSettings.field.orderNumber': '订单号',
  'printoutSettings.field.ticketNumber': '小票号',
  'printoutSettings.field.tableNumber': '桌号',
  'printoutSettings.field.suggestedTip': '建议小费',
  'printoutSettings.field.itemizedDishes': '菜品项',
  'printoutSettings.field.customerSignature': '客户签名',
  'printoutSettings.field.orderNote': '订单备注',
  'printoutSettings.field.showItemsThatAreZeroPrice': '显示价格为0的菜品',
  'printoutSettings.field.showPrice': '显示价格',
  'printoutSettings.field.batchNumber': '批次号',
  'printoutSettings.field.showCustomizationsAndPreferencesThatAreZeroPrice': '显示价格为0的附加选项和菜品偏好',
  'printoutSettings.field.printCustomerCopyOfReceipt': '打印收据客户联',
  'printoutSettings.field.prices': '价格',
  'printoutSettings.field.time': '打印时间',
  'printoutSettings.field.topSpacingRows': '顶部留白行数',
  'printoutSettings.field.lineItemSpacingRows': '菜品项间隔留白行数',
  'printoutSettings.field.bottomSpacingRows': '底部留白行数',
  'printoutSettings.field.fontSize': '字体大小',
  'printoutSettings.field.printerDisplayName': '打印机展示名称',
  'printoutSettings.field.printerDisplayNameOnKitcheTicket':
    '厨房小票会展示打印机展示名称。如需查看或更改展示名称，请跳转{link}页',
  'printoutSettings.field.printerDisplayNameOnPackingTicket':
    '外带单会展示打印机展示名称。如需查看或更改展示名称，请跳转{link}页',
  'printoutSettings.field.billInformation': '账单信息',
  'printoutSettings.field.paymentStatus': '支付状态',
  'printoutSettings.field.autoPrintWhenItemsOrOrdersVoided': '打印作废菜品和订单',
  'printoutSettings.packing.field.autoPrintWhenItemsOrOrdersVoided': '打印作废菜品和订单',
  'printoutSettings.field.server_name': '服务员姓名',
  'printoutSettings.field.server_name.bold': '加粗',
  'printoutSettings.field.net_sales': '税前营业额',
  'printoutSettings.field.grand_total': '税后营业额',
  'printoutSettings.field.show_order_note': '订单备注',
  'printoutSettings.field.show_dish_note': '菜品备注',
  'printoutSettings.field.printerPriceOnKitcheTicket': '要查看和编辑价格的显示方式，请转到{link}选项卡',
  'printoutSettings.field.printItemsPrice': '打印菜品价格',
  'printoutSettings.field.printCustomizationsAndPreferencePrice': '打印附加选项和偏好设置价格',
  'printoutSettings.field.qrCode': '二维码',
  'printoutSettings.field.qrCode.uploadImage': '上传图片',
  'printoutSettings.field.qrCode.tooltip': `
    <span>支持上传1M以下.jpg, .jpeg, .png格式的文件</span>
    <span>建议最小尺寸为：164 x 164</span>
  `,
  'printoutSettings.field.qrCode.tooLargeSize': '图像大小需要在1M以内',
  'printoutSettings.field.qrCode.wrongFileType': '图片格式只能为.jpg, .jpeg, .png',
  'printoutSettings.field.qrCode.uploadImageFailed': '处理图片失败，请重新操作',
  'printoutSettings.field.footer': '底部宣传语',
  'printoutSettings.field.footer.placeholder': '输入文字',
  'printoutSettings.field.footer.tooltip': `
    <span>建议一行中输入字符数</span>
    <span>标准字号：20个</span>
    <span>加大字号：12个</span>
  `,
  'printoutSettings.field.groupDishesBySeats': '按照座位分组打印',
  'printoutSettings.field.showKitchenName': '使用后厨别名进行打印',
  'printoutSettings.field.formula': '配方',
  'printoutSettings.field.formula1': '打印菜品代码和附加选项代码',
  'printoutSettings.field.formula1.tips': '用于指导门店员工制作出品',
  'printoutSettings.field.formula2': '打印二维码',
  'printoutSettings.field.formula2.tips': '用于自动化设备制作出品，我们将以下述格式生成二维码，需自助茶饮机厂商适配',
  'printoutSettings.field.formula2.example': '?o=订单号&equ=取餐号|菜品代码|选项1代码,选项2代码,选项3代码|',

  'printoutSettings.ticketNumberStartsFrom': '小票号起始号码',
  'printoutSettings.ticketNumberStartsFrom.tooltip': '（新设置将于下一个营业日开始时生效）',
  'printoutSettings.groupIdenticalDishes': '相同菜品合并打印',
  'printoutSettings.commandPrinting': '指令打印',
  'printoutSettings.commonPrintingExcludeLabelTicket': '指令打印(不包括贴纸)',
  'printoutSettings.clockoutSummaryCopy': '员工打卡下班时打印小结',
  'printoutSettings.enablePrintingRecoveryMode.title': '开启打印恢复模式',
  'printoutSettings.enablePrintingRecoveryMode.description':
    '如果此选项被开启，当一台终端打印失败时，系统自动尝试切换到其他设备以恢复打印。此特性只有在餐厅拥有多台终端的情况下生效。',
  'printoutSettings.addTipsLayoutPreferenceForReceipt': '小费填写格式',
  'printoutSettings.addTipsLayoutPreferenceForReceipt.checkbox': '勾选',
  'printoutSettings.addTipsLayoutPreferenceForReceipt.handwritten': '手写',
  'printoutSettings.printDishNameWithMappedCustomizations': '当附加选项配置了打印机时打印菜品名',
  'printoutSettings.printDishNameWithMappedCustomizations.description':
    '当此设置被开启时，会在附加选项后打印用括号包裹的菜品名。',
  'printoutSettings.showTextWhenCreditCardFeesAreAutoApplied': '自动应用信用卡费用时显示文本',
  'printoutSettings.showTextWhenCreditCardFeesAreAutoApplied.description':
    '只有在“金额调整管理”页面创建的有效费用才能被应用',
  'printoutSettings.displayPaymentTotalsForCashAndCreditCard': '显示现金和信用卡的支付总额',
  'printoutSettings.highlightOpenOrders': '未完成订单一行高亮（黑底白字）显示',
  'printoutSettings.mandatorilySendAllDishedBeforePrintingBill': '打印账单时所有菜品都必须送厨',
  'printoutSettings.multiplePrintersAreAvailable': '当匹配到多台打印机可用时手动选择设备',

  'printoutSettings.byOrderSourceSales': '细分订单类型来源销售数据',
  'printoutSettings.byServiceTypeSales': '细分服务类型销售数据',
  'printoutSettings.byOnlinePlatformSales': '线上平台销售数据',
  'printoutSettings.printCustomizationWithDish': '当附加选项配置了打印机时仍随菜品打印',
  'printoutSettings.printCustomizationWithDish.description': '开关关闭时，仅未配置打印机的附加选项会随菜品一起打印。',
  'printoutSettings.print_one_dish_one_print_by_meal_count': '一菜一单模式下分开打印合并数量的菜品',
  'printoutSettings.printItemsPrice.always': '打印菜品和价格',
  'printoutSettings.printItemsPrice.without_price': '只打印菜品 ',
  'printoutSettings.printItemsPrice.exclude_zero_price': '打印菜品和价格，0元价格不打印',
  'printoutSettings.printCustomizationsAndPreferencePrice.always': '打印附加选项和偏好设置及其价格',
  'printoutSettings.printCustomizationsAndPreferencePrice.without_price': '只打印附加选项和偏好设置',
  'printoutSettings.printCustomizationsAndPreferencePrice.exclude_zero_price':
    '打印附加选项和偏好设置及其价格，0元价格不打印',
  'printoutSettings.field.allowSpecificItemsNotPrintOnTickets.runner': '允许特定菜品不打印在跑堂小票上',
  'printoutSettings.field.allowSpecificItemsNotPrintOnTickets.packing': '允许特定菜品不打印在外带单上',
  'printoutSettings.field.allowSpecificItemsNotPrintOnTickets.table.product': '不需要打印的菜品',
  'printoutSettings.field.allowSpecificItemsNotPrintOnTickets.table.action': '操作',
  'printoutSettings.field.allowSpecificItemsNotPrintOnTickets.table.add': '+ 新增',
  'printoutSettings.field.allowSpecificItemsNotPrintOnTickets.table.noData': '暂未选择菜品',
  'printoutSettings.field.allowSpecificItemsNotPrintOnTickets.modal.title.runner': '选择不打印在跑堂小票上的菜品',
  'printoutSettings.field.allowSpecificItemsNotPrintOnTickets.modal.title.packing': '选择不打印在外带单上的菜品',
  'printoutSettings.field.allowSpecificItemsNotPrintOnTickets.modal.save': '保存',
  'printoutSettings.field.autoByFullPaid': '当票据自动打印条件设为支付成功时，必须全额付清才能打印',
  'printoutSettings.update.success': '更新打印票据设置成功!',
  'printoutSettings.update.fail': '更新打印票据设置失败!',
  'printoutSettings.printingTaskExpirationTime.never': '永不过期',
  'printoutSettings.printingTaskExpirationTime.interval': '过期时间',
};
